<template>
  <div class="header bgColorfff">
    <template v-if="!showBack">
      <div class="center color333 one-center">{{ title }}</div>
    </template>
    <template v-else>
      <div class="leading" @click="toBack">
        <img src="@/assets/img/icon/btn-back-black.png" />
      </div>
      <div class="center color333">{{ title }}</div>
      <div class="actions"></div>
    </template>
  </div>
</template>

<script>
export default {
  name: "hander",
  props: {
    title: {
      type: String,
      required: true,
    },
    showBack: {
      type: Boolean,
      default: false,
    },
    back: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toBack() {
      this.$router.go(-1);

    },
  },
};
</script>

<style scoped lang="scss">
.header {
  position: sticky;
  top: 0;
  background-color: transparent;
  width: 100%;
  height: 0.88rem;
  line-height: 0.88rem;
  text-align: center;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  padding: 0 0.29rem;
  font-weight: 700;

  .leading {
    color: #030303;
    font-size: 0.4rem;
    display: flex;
    align-items: center;
    width: 1rem;
    img {
      height: 0.3rem;
    }
  }

  .center {
    font-size: 0.36rem;
    font-weight: bold;
    max-width: 60%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-left: -1rem;
  }

  .one-center {
    max-width: 100%;
    width: 100%;
    text-align: center;
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subcomponents/header.vue